import ViewStudent from "@/pages/students/view-student";
import PrivateLayout from "@/components/layouts/private-layout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/students/$studentId/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <ViewStudent />
    </PrivateLayout>
  );
}
